import { createTheme, PaletteMode, responsiveFontSizes, Theme } from '@mui/material';
import { grey } from '@mui/material/colors';
import { TenantTheme } from 'modules/application/types';

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    appBar: TypeBackground;
    notes: TypeBackground;
  }

  interface PaletteOptions {
    appBar: Partial<TypeBackground>;
    notes: Partial<TypeBackground>;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface PaletteColor extends ColorPartial { }
}

const lightModeColors = {
  background: {
    default: '#f5f5f5',
  },
  appBar: {
    default: '#FFFFFF',
  },
  notes: {
    default: '#0000001a',
  }
};

const darkModeColors = {
  appBar: {
    default: grey[900]
  },
  notes: {
    default: '#0000001a'
  }
};

const getPaletteTheme = (mode: PaletteMode) => {
  return createTheme({
    palette: {
      mode,
      ...(mode === 'light' ? lightModeColors : darkModeColors),
    },
  });
};

export const createAppTheme = (mode: PaletteMode): Theme => {
  const paletteTheme = getPaletteTheme(mode);

  const baseTheme = createTheme({
    ...paletteTheme,

    components: {
      MuiAppBar: {
        variants: [
          {
            props: { color: 'default' },
            style: {
              color: paletteTheme.palette.primary.main,
              backgroundColor: paletteTheme.palette.appBar.default,
              zIndex: paletteTheme.zIndex.drawer + 1
            },
          },
        ],
      },
    }
  });


  const responsiveFontSizeTheme = responsiveFontSizes(baseTheme);
  return responsiveFontSizeTheme;
};

export const createTenantTheme = (mainTheme: Theme, tenantTheme: TenantTheme): Theme => {

  return createTheme({
    ...mainTheme,
    palette: {
      ...mainTheme.palette,
      primary: tenantTheme.primary && {
        main: tenantTheme.primary.main,
        contrastText: tenantTheme.primary.contrastText
      },
      secondary: tenantTheme.secondary && {
        main: tenantTheme.secondary.main,
        contrastText: tenantTheme.secondary.contrastText
      }
    }
  });
};